export default __webpack_public_path__ + "static/aviation-3bd88637dda2f632155b2a501d3dc7c7.jpg";